<template>
  <div v-if="Orders" id="billing" class="module">
    <h1>Billing</h1>

    <el-card class="box-card">
      <div class="heading flexbox flexbox__v-center">
        <h1 v-if="Orders">
          SPC Membership active through {{ Orders[0].date | longDate }}
        </h1>

        <!-- <el-button type="primary" size="small">Pay invoice</el-button> -->
        <!-- <el-button type="primary" size="small">Add/edit memo</el-button> -->
      </div>

      <hr />

      <el-table :data="Orders">
        <el-table-column label="Order" width="110">
          <template slot-scope="scope">
            <!-- <a href="#"> -->
            #
            <span>{{ scope.row.bewpi_invoice_number }}</span>
            <!-- &nbsp; -->
            <!-- <i class="el-icon-download"></i> -->
            <!-- </a> -->
          </template>
        </el-table-column>

        <el-table-column label="Membership Cycle" width="275">
          <template slot-scope="scope">
            {{ scope.row.date | longDate }}
          </template>
        </el-table-column>

        <el-table-column label="Status" width="130">
          <template slot-scope="scope">
            <i
              :class="
                'fas fa-circle ' +
                  (scope.row.status != 'Active' ? 'primary' : 'red')
              "
            ></i>
            &nbsp;Paid
          </template>
        </el-table-column>

        <el-table-column label="Total">
          <template slot-scope="scope">
            <span>{{ scope.row.order_total | currency }}</span>
            &nbsp;&ndash;&nbsp;
            <span>{{ scope.row.company_subscription_id | capitalize }}</span>
          </template>
        </el-table-column>
      </el-table>

      <h4>ESP payment section TBD</h4>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import ApolloBilling from "@/graphql/Company/Billing.gql";

export default {
  name: "CompanyBilling",
  filters: {
    longDate: function(shortDate) {
      return new Date(shortDate).toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    }
  },
  computed: {
    membershipCycle: function() {
      return this.$attrs.startDate + " - " + this.$attrs.expDate;
    },
    memberStatus: function() {
      return this.$attrs.status ? "Active" : "Not active";
    },
    tableData: function() {
      return [
        {
          order: this.$attrs.order,
          membershipCycle: this.membershipCycle,
          status: this.memberStatus,
          total: this.$attrs.total,
          size: this.$attrs.size
        }
      ];
    }
  },
  apollo: {
    Orders: {
      query: ApolloBilling,
      variables() {
        return {
          userID: this.$store.state.user.id
        };
      },
      update(data) {
        return !_.isEmpty(data.User[0].Orders) ? data.User[0].Orders : false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  .el-button {
    &:first-of-type {
      margin-left: auto;
    }
  }
}
</style>
